import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

export default ({
  color = defaultIconColor,
  hasChildren,
  hasParent,
}: SVGComponentPropsType & {
  hasChildren?: boolean;
  hasParent?: boolean;
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {hasParent && <line x1="12" y1="0" x2="12" y2="6" stroke={color} strokeWidth="2" />}
      <rect x="7" y="7" width="10" height="10" rx="3" fill="white" stroke={color} strokeWidth="2" />
      {hasChildren && <line x1="12" y1="18" x2="12" y2="24" stroke={color} strokeWidth="2" />}
    </svg>
  );
};
